import React from "react";
import "./input.css";

const Input = (props) => {
  return (
    <div>
      <input {...props} />
    </div>
  );
};
export default Input;
